import { useRef } from 'react'
import { IconButton } from '@/components'
import { useFiltersApi } from '@/hooks/useApi/useFiltersApi/useFiltersApi'
import UsageAndCostDropdownActions from '../UsageAndCostDropdownActions/UsageAndCostDropdownActions'
import { useAnalyticsFiltersGetParams } from '@/features/Analytics/hooks/useAnalyticsFiltersGetParams'
import { DEFAULT_ANALYTICS_FILTERING } from '@/utils/constants'
import { applyStandardUOM } from '@/components/data/AnalyticsFilters/applyStandardUOM'
import { CommodityFilter } from '@/components/core/filters/CommodityFilter'
import { useDashboardUsageAndCostFiltersStore } from '@/stores/useDashboardUsageAndCostFiltersStore'

const buttonDetails: React.ComponentProps<typeof IconButton> = {
    icon: 'more_horiz',
    size: 'large',
    name: 'icon',
    variant: 'ghostSecondary',
    className: 'block',
}

const UsageAndCostFilterContainer = () => {
    const containerRef = useRef<HTMLDivElement>(null)
    const { useCommoditiesQuery } = useFiltersApi()
    const updateActiveFilter = useDashboardUsageAndCostFiltersStore(
        (state) => state.updateActiveFilter
    )
    const activeFilters = useDashboardUsageAndCostFiltersStore(
        (state) => state.activeFilters
    )
    const params = useAnalyticsFiltersGetParams(activeFilters)
    const commoditiesQuery = useCommoditiesQuery({
        'nodeIds[]': params['nodeIds[]'],
    })
    const { data } = commoditiesQuery

    return (
        <div className="flex items-center gap-4">
            <CommodityFilter
                name="dashboard-commodity-filter"
                containerRef={containerRef}
                multiple={false}
                value={activeFilters.commodity.map((id) => id.toString())}
                defaultValue={DEFAULT_ANALYTICS_FILTERING.commodity.map((id) =>
                    id.toString()
                )}
                onChange={(value: string[]) => {
                    const commodityId = parseInt(value[0])
                    updateActiveFilter('commodity', [commodityId])

                    applyStandardUOM(
                        commodityId,
                        data,
                        activeFilters,
                        updateActiveFilter
                    )
                }}
                params={{
                    'nodeIds[]': params['nodeIds[]'],
                }}
            />
            <UsageAndCostDropdownActions buttonProps={buttonDetails} />
        </div>
    )
}

export default UsageAndCostFilterContainer
